/**
 * B+D visual redesign — Claim Your Cricket.
 *
 * Quiet text treatment for anonymous users with meaningful stored cricket
 * state. No banner chrome, no colored fill, no border. A single calm line
 * with a text link — it should feel like a note, not a prompt.
 *
 * Web-only: the parent (Chat.jsx) hides this on native until the native
 * OAuth deep-link continuity path is proven end-to-end.
 *
 * Props:
 *   onSignIn: function — routes to sign-in (Google OAuth)
 *   onDismiss: function — dismisses (session-only)
 *
 * Renders nothing if not visible. The parent controls visibility via
 * GET /api/home/anonymous-state.
 */

import React from "react";

export default function ClaimYourCricketBanner({ onSignIn, onDismiss }) {
  return (
    <div
      className="px-1 py-2 flex items-baseline justify-between gap-3"
      data-testid="claim-your-cricket-banner"
    >
      <p className="text-sm text-neutral-500">
        Your cricket is saved here.{" "}
        <button
          onClick={onSignIn}
          className="text-neutral-800 underline underline-offset-2 decoration-neutral-300"
          data-testid="claim-your-cricket-signin"
        >
          Sign in to keep it with you
        </button>
      </p>
      <button
        onClick={onDismiss}
        className="shrink-0 text-neutral-400 text-sm"
        aria-label="Dismiss"
        data-testid="claim-your-cricket-dismiss"
      >
        ×
      </button>
    </div>
  );
}
